const v = (name: string) => `var(--chakra-colors-${name})`

export const vizCatVar = (slot: number): string => v(`viz-cat-${((Math.trunc(slot) - 1) % 8 + 8) % 8 + 1}`)
export const seriesColor = (index: number): string => vizCatVar(index + 1)
export const vizSeqVar = (step: 100 | 200 | 300 | 400 | 500 | 600 | 700): string => v(`viz-seq-${step}`)

export const vizDiv = { neg: v('viz-div-neg'), mid: v('viz-div-mid'), pos: v('viz-div-pos') } as const

const KNOWN_PARTIES = new Set(['democrat', 'republican', 'independent', 'libertarian', 'green'])
export const vizPartyVar = (party: string): string => {
  const key = party.trim().toLowerCase()
  const norm = key === 'democratic' ? 'democrat' : key
  return v(`viz-party-${KNOWN_PARTIES.has(norm) ? norm : 'other'}`)
}

export const chartInk = {
  axis: v('muted'),
  grid: v('border-2'),
  baseline: v('border'),
  tooltipBg: v('surface'),
} as const

// Recharts theming — spread into axis/grid/tooltip elements.
export const chartTheme = {
  axis: { tick: { fill: chartInk.axis, fontSize: 12 }, stroke: chartInk.baseline },
  grid: { stroke: chartInk.grid, strokeDasharray: '3 3' as const },
  tooltip: {
    contentStyle: {
      background: chartInk.tooltipBg,
      border: `1px solid ${chartInk.grid}`,
      borderRadius: 8,
      color: v('ink'),
    },
  },
} as const

export interface TopNSlot<T> { item: T; colorVar: string; isOther: boolean }
export function topNWithOther<T>(items: T[], n: number): TopNSlot<T>[] {
  const head: TopNSlot<T>[] = items
    .slice(0, n)
    .map((item, i) => ({ item, colorVar: vizCatVar(i + 1), isOther: false }))
  if (items.length > n) {
    head.push({ item: items[n], colorVar: v('viz-party-other'), isOther: true })
  }
  return head
}
